import ScreenHeader from 'components/ScreenHeader'
import ScreenContainer from 'components/ScreenContainer'

import ColoursSection from './ColoursSection'
import TypographySection from './TypographySection'
import InputsSection from './InputsSection'
import ButtonsSection from './ButtonsSection'

const DesignSystem = () => (
  <ScreenContainer>
    <ScreenHeader title="Design System" />
    <TypographySection />
    <ColoursSection />
    <InputsSection />
    <ButtonsSection />
  </ScreenContainer>
)

export default DesignSystem
